import { app } from '~/modules/app'
import { cache } from '~/modules/cache'
import { main } from '~/modules/main'
import { modal } from '~/modules/modal'
import { notifications } from '~/modules/notifications'
import { product } from '~/modules/product'

export default [app, main, cache, modal, notifications, product] as const
